"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectDefaultExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var examples_1 = require("@shared/examples");
var EXAMPLE_SRC = 'components/select/examples/default.ts';
var SelectDefaultExample = /** @class */ (function () {
    function SelectDefaultExample() {
        this.basic = false;
        this.fluid = false;
        this.options = ['First', 'Second', 'Third', 'Fourth'];
    }
    SelectDefaultExample.prototype.view = function () {
        return (0, mithril_1.default)(examples_1.Example, { options: this.renderOptions(), src: EXAMPLE_SRC }, [
            (0, mithril_1.default)(_1.Select, {
                contentLeft: (0, examples_1.renderContent)(this.contentLeft, _1.Icons.USERS),
                contentRight: (0, examples_1.renderContent)(this.contentRight, _1.Icons.SEARCH),
                basic: this.basic,
                disabled: this.disabled,
                fluid: this.fluid,
                intent: this.intent,
                options: this.options,
                size: this.size,
                defaultValue: 'Third'
            })
        ]);
    };
    SelectDefaultExample.prototype.renderOptions = function () {
        var _this = this;
        return [
            (0, mithril_1.default)('h5', 'Size'),
            (0, mithril_1.default)(examples_1.SizeSelect, { onSelect: function (size) { return _this.size = size; } }),
            (0, mithril_1.default)('h5', 'Intent'),
            (0, mithril_1.default)(examples_1.IntentSelect, { onSelect: function (intent) { return _this.intent = intent; } }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.disabled,
                label: 'Disabled',
                onchange: function () { return _this.disabled = !_this.disabled; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.fluid,
                label: 'Fluid',
                onchange: function () { return _this.fluid = !_this.fluid; }
            }),
            (0, mithril_1.default)(_1.Switch, {
                checked: this.basic,
                label: 'Basic',
                onchange: function () { return _this.basic = !_this.basic; }
            }),
            (0, mithril_1.default)('h5', 'Left content'),
            (0, mithril_1.default)(examples_1.ContentSelect, { onSelect: function (content) { return _this.contentLeft = content; } }),
            (0, mithril_1.default)('h5', 'Right content'),
            (0, mithril_1.default)(examples_1.ContentSelect, { onSelect: function (content) { return _this.contentRight = content; } })
        ];
    };
    return SelectDefaultExample;
}());
exports.SelectDefaultExample = SelectDefaultExample;
